import { MesfModal } from "@dexteel/mesf-core";
import { Box } from "@mui/material";

type Props = {
	open: boolean;
	url: string | null;
	sectionName: string;
	rev?: number | null;
	fileName?: string | null;
	onClose: () => void;
};

export const DrawingModal = ({
	open,
	url,
	sectionName,
	rev = null,
	fileName = null,
	onClose,
}: Props) => (
	<MesfModal
		id="modal-inspection-drawing"
		title={
			rev === null
				? `DRAWING · ${sectionName}`
				: `DRAWING · ${sectionName} · Rev ${rev}`
		}
		subtitle={fileName ?? undefined}
		open={open && url !== null}
		handleClose={onClose}
		maxWidth="xl"
	>
		<MesfModal.Content style={{ padding: "15px 30px" }} dividers>
			<Box
				component="img"
				src={url ?? ""}
				alt={`${sectionName} profile drawing`}
				sx={{
					display: "block",
					margin: "0 auto",
					maxHeight: "78vh",
					maxWidth: "100%",
					objectFit: "contain",
				}}
			/>
		</MesfModal.Content>
	</MesfModal>
);
